import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledQuotesSection = styled.section`
  max-width: 1000px;

  .inner {
    display: flex;
    flex-direction: column;
  }

  .quote-container {
    ${({ theme }) => theme.mixins.boxShadow};
    background-color: var(--light-navy);
    border-radius: var(--border-radius);
    padding: 40px;
    margin-top: 50px;
    text-align: center;
    position: relative;
    transition: var(--transition);

    &:before {
      content: '"';
      position: absolute;
      top: 10px;
      left: 20px;
      font-size: 80px;
      color: var(--green);
      font-family: Georgia, serif;
      line-height: 1;
    }

    &:after {
      content: '"';
      position: absolute;
      bottom: -10px;
      right: 20px;
      font-size: 80px;
      color: var(--green);
      font-family: Georgia, serif;
      line-height: 1;
    }

    @media (max-width: 768px) {
      padding: 30px;

      &:before,
      &:after {
        font-size: 60px;
      }
    }
  }

  .quote-text {
    font-size: var(--fz-xl);
    line-height: 1.4;
    color: var(--lightest-slate);
    margin-bottom: 20px;
    font-style: italic;

    @media (max-width: 768px) {
      font-size: var(--fz-lg);
    }
  }

  .quote-attribution {
    color: var(--green);
    font-size: var(--fz-md);
    font-weight: 600;
    margin-bottom: 5px;
  }

  .quote-source {
    color: var(--slate);
    font-size: var(--fz-sm);
    font-style: italic;
  }

  .more-button {
    ${({ theme }) => theme.mixins.button};
    margin: 40px auto 0;
  }
`;

const Quotes = ({ quotes }) => {
  const [currentQuote, setCurrentQuote] = useState(null);
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  useEffect(() => {
    // Select a random quote from the provided quotes
    if (quotes && quotes.length > 0) {
      const randomIndex = Math.floor(Math.random() * quotes.length);
      setCurrentQuote(quotes[randomIndex]);
    }
  }, [quotes]);

  if (!currentQuote) {
    return null;
  }

  const { frontmatter, html } = currentQuote;
  const { author, source } = frontmatter;

  return (
    <StyledQuotesSection ref={revealContainer}>
      <h2>Daily Inspiration</h2>

      <Link className="inline-link archive-link" to="/quotes">
        view all quotes
      </Link>

      <div className="quote-container">
        <div className="quote-text" dangerouslySetInnerHTML={{ __html: html.split('\n')[0] }} />
        <div className="quote-attribution">— {author}</div>
        {source && <div className="quote-source">{source}</div>}
      </div>
    </StyledQuotesSection>
  );
};

export default Quotes;
